import { render, staticRenderFns } from "./SipCallLog.vue?vue&type=template&id=7a9896b2&"
import script from "./SipCallLog.vue?vue&type=script&lang=js&"
export * from "./SipCallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports